import React from "react";
import { graphql } from "gatsby";
import Layout from "../../layout/default/Layout";
import { Helmet } from "react-helmet";
import { Router, navigate } from "@reach/router";

import { SearchRentalBusinessPage } from "@coninsa-site/property";
import FloatingWhatsappBtn from "modules/home/components/FloatingWhatsappBtn";
import { capitalizeFirstLetter } from "./vivienda";

function Landing({ data, location }) {
  const arr = location.pathname.replace("/arrendamientos/comercio/", "").split("/");
  
    /**
     * { 
     *   ciudad: 'cartagena', 
     *   departamento: 'cundinamarca', 
     *   'tipo-de-inmueble': 'apartamento' s
     * }
     */
    let info = {};
    let i = 0;
  
    for (i = 0; i < arr.length; i = i + 2) {
      info[arr[i]] = arr[i + 1];
    }
  
    let title = '';
  
    if (info['departamento'] && info['ciudad'] && info['tipo-de-inmueble']) {
      title = `Arrendamiento de inmuebles comercio de tipo ${info['tipo-de-inmueble']} en ${capitalizeFirstLetter(info['ciudad'])}, ${capitalizeFirstLetter(info['departamento'])} | Coninsa`
    } else if (info['departamento'] && info['ciudad']) {
        title = `Arrendamiento de inmuebles comercio en ${capitalizeFirstLetter(info['ciudad'])}, ${capitalizeFirstLetter(info['departamento'])} | Coninsa` 
    } else if (info['departamento'] && info['tipo-de-inmueble']) {
        title = `Arrendamiento de inmuebles comercio de tipo ${info['tipo-de-inmueble']} en ${capitalizeFirstLetter(info['departamento'])} | Coninsa`
    } else if (info['ciudad'] && info['tipo-de-inmueble']) {
        title = `Arrendamiento de inmuebles comercio de tipo ${info['tipo-de-inmueble']} en ${capitalizeFirstLetter(info['ciudad'])} | Coninsa`
    } else if (info['departamento']) {
        title = `Arrendamiento de inmuebles comercio en ${capitalizeFirstLetter(info['departamento'])} | Coninsa`
    } else if (info['ciudad']) {
        title = `Arrendamiento de inmuebles comercio en ${capitalizeFirstLetter(info['ciudad'])} | Coninsa`
    } else if (info['tipo-de-inmueble']) {
        title = `Arrendamiento de inmuebles comercio de tipo ${info['tipo-de-inmueble']} | Coninsa`
    } else {
        title = `Arrendamiento de inmuebles comercio en Colombia | Coninsa`;
    }
  
    let description = ''
  
    if (info['departamento'] && info['ciudad'] && info['tipo-de-inmueble']) {
      description = `Descubre la mejor selección de comercios en arrendamiento de tipo ${info['tipo-de-inmueble']} en
      ${capitalizeFirstLetter(info['ciudad'])}, ${capitalizeFirstLetter(info['departamento'])} con Coninsa.
      Encuentra apartamentos y casas en alquiler en las mejores ubicaciones, con opciones que se adaptan a todas
      tus necesidades y presupuesto. Confía en nuestra experiencia y servicio para encontrar tu próximo hogar.`
    } else if (info['departamento'] && info['ciudad']) {
        description = `Descubre la mejor selección de comercios en arrendamiento en ${capitalizeFirstLetter(info['ciudad'])},
        ${capitalizeFirstLetter(info['departamento'])} con Coninsa. Encuentra apartamentos y casas en alquiler en las mejores
        ubicaciones, con opciones que se adaptan a todas tus necesidades y presupuesto. Confía en nuestra experiencia y servicio para encontrar tu próximo hogar.` 
    } else if (info['departamento'] && info['tipo-de-inmueble']) {
        description = `Descubre la mejor selección de comercios en arrendamiento de tipo ${info['tipo-de-inmueble']} en
        ${capitalizeFirstLetter(info['departamento'])} con Coninsa. Encuentra apartamentos y casas en alquiler en las mejores ubicaciones,
        con opciones que se adaptan a todas tus necesidades y presupuesto. Confía en nuestra experiencia y servicio para encontrar tu próximo hogar.`
    } else if (info['ciudad'] && info['tipo-de-inmueble']) {
        description = `Descubre la mejor selección de comercios en arrendamiento de tipo ${info['tipo-de-inmueble']} en
        ${capitalizeFirstLetter(info['ciudad'])} con Coninsa. Encuentra apartamentos y casas en alquiler en las mejores ubicaciones,
        con opciones que se adaptan a todas tus necesidades y presupuesto. Confía en nuestra experiencia y servicio para encontrar tu próximo hogar.`
    } else if (info['departamento']) {
        description = `Descubre la mejor selección de comercios en arrendamiento en ${capitalizeFirstLetter(info['departamento'])} con Coninsa. 
        Encuentra apartamentos y casas en alquiler en las mejores ubicaciones,con opciones que se adaptan a todas tus necesidades y presupuesto.
        Confía en nuestra experiencia y servicio para encontrar tu próximo hogar.`
    } else if (info['ciudad']) {
        description = `Descubre la mejor selección de comercios en arrendamiento en ${capitalizeFirstLetter(info['ciudad'])} con Coninsa. 
        Encuentra apartamentos y casas en alquiler en las mejores ubicaciones,con opciones que se adaptan a todas tus necesidades y presupuesto.
        Confía en nuestra experiencia y servicio para encontrar tu próximo hogar.`
    } else if (info['tipo-de-inmueble']) {
        description = `Descubre la mejor selección de comercios en arrendamiento de tipo ${info['tipo-de-inmueble']} con Coninsa.
        Encuentra apartamentos y casas en alquiler en las mejores ubicaciones, con opciones que se adaptan a todas tus necesidades
        y presupuesto. Confía en nuestra experiencia y servicio para encontrar tu próximo hogar.`
    } else {
        description = `Descubre la mejor selección de comercios en arrendamiento en Colombia con Coninsa.
        Encuentra apartamentos y casas en alquiler en las mejores ubicaciones, con opciones que se adaptan a todas tus necesidades y presupuesto.
        Confía en nuestra experiencia y servicio para encontrar tu próximo hogar.`;
    }

  return (
    <Layout
      headerAds={data?.drupal?.ads?.header}
      popupAds={data?.drupal?.ads?.popUp}
      footerAds={data?.drupal?.ads?.footer}
    >
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link
          rel="canonical"
          href={`https://www.coninsa.co${location.pathname}`}
        />
      </Helmet>

      <FloatingWhatsappBtn path="https://api.whatsapp.com/send?phone=573014726883&text=Hola!" />

      <Router basepath="/arrendamientos/comercio">
        <SearchRentalBusinessPage path="*" navigate={navigate} />
      </Router>
    </Layout>
  );
}

export const query = graphql`
  query CommercePageQuery {
    drupal {
      ads: getAdsByUrl(path: "/arrendamientos/comercio") {
        header {
          id: nid
          image: fieldImage {
            url
          }
          url: fieldUrl {
            uri
            title
          }
        }
        popUp {
          id: nid
          image: fieldImage {
            url
          }
          url: fieldUrl {
            uri
            title
          }
        }
        footer {
          id: nid
          image: fieldImage {
            url
          }
          url: fieldUrl {
            uri
            title
          }
        }
      }
    }
  }
`;

export default Landing;
